import { React } from 'Imports';
import { MenuItem } from 'MaterialUIComponents';
import { ClickAwayListener, InputAdornment, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import * as scssStyles from '$CSS/settings.scss';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require('./DropdownSearchField.scss') as {
    searchBar: string;
};

interface IDropdownSearchFieldProps {
    onChange: (value: string) => void;
    searchFilter: string;
    onSearchFieldFocus: () => void;
    onSearchFieldFocusLost: () => void;
    placeholder?: string;
    hideAdornments?: boolean;
}

const DropdownSearchField = (props: IDropdownSearchFieldProps) => {
    const [searchFieldHasFocus, setSearchFieldHasFocus] = useState(false);

    const isFiltering = props.searchFilter.length > 0;
    const showSearchIcon = !isFiltering && !props.hideAdornments;

    const baseInputProps = {
        sx: {
            textAlign: 'left',
            height: '28px',
            paddingLeft: '8px',
            paddingRight: '8px',
            fontSize: isEncompass ? '16px' : '14px',
        },
    };

    const notFilteringInputProps = {
        ...baseInputProps,

        startAdornment: (
            <InputAdornment position="start">
                <FontAwesomeIcon icon={faSearch} color={scssStyles.searchMagnifyingGlassColor} />
            </InputAdornment>
        ),
    };

    const filteringInputProps = {
        ...baseInputProps,
        sx: {
            ...baseInputProps.sx,
            cursor: 'pointer',
        },
        endAdornment: (
            <InputAdornment position="end" onClick={() => props.onChange('')}>
                <FontAwesomeIcon icon={faXmark} color={scssStyles.searchFieldXmarkColor} />
            </InputAdornment>
        ),
    };

    const getInputProps = () => {
        if (isEncompass) {
            if (showSearchIcon) {
                return notFilteringInputProps;
            } else if (isFiltering) {
                return filteringInputProps;
            } else {
                return baseInputProps;
            }
        } else {
            if (isFiltering) {
                return filteringInputProps;
            } else {
                return baseInputProps;
            }
        }
    };

    return (
        <MenuItem
            onKeyDown={(e) => e.stopPropagation()}
            disableRipple={true}
            sx={{
                '&.Mui-focusVisible': {
                    backgroundColor: 'transparent',
                },
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                padding: isEncompass ? '16px 16px 8px 16px' : '8px',
            }}
        >
            <ClickAwayListener onClickAway={() => setSearchFieldHasFocus(false)}>
                <TextField
                    variant="outlined"
                    placeholder={searchFieldHasFocus ? '' : props.placeholder ? props.placeholder : 'Search ...'}
                    value={props.searchFilter}
                    onChange={(e) => props.onChange(e.target.value)}
                    onFocus={() => {
                        props.onSearchFieldFocus();
                        setSearchFieldHasFocus(true);
                    }}
                    onBlur={() => {
                        props.onSearchFieldFocusLost();
                        setSearchFieldHasFocus(false);
                    }}
                    focused={searchFieldHasFocus}
                    className={styles.searchBar}
                    InputProps={getInputProps()}
                    sx={{
                        fontWeight: 400,
                        fontSize: isEncompass ? '14px' : '12px',
                        fieldset: {
                            border: searchFieldHasFocus
                                ? isEncompass
                                    ? '1px solid #0D7AC5 !important'
                                    : '1px solid #25477B !important'
                                : isEncompass
                                  ? '1px solid #C4CBD4 !important'
                                  : '1px solid #C4CBD7 !important',
                        },
                        marginTop: isEncompass ? '-8px' : 'inherit',
                    }}
                />
            </ClickAwayListener>
        </MenuItem>
    );
};

export default DropdownSearchField;
